import { readable, writable } from 'svelte/store';
import { persisted } from 'svelte-local-storage-store'

//export const groups = persisted('groups',{'ksA2LAcd':'Los Mejores'});
export const groups = persisted('groups',{});
export const partidaId = persisted('last_partidaId');
export const group = persisted('last_group');